import { useNavigate } from 'react-router-dom';
import { Button } from '@ds';

type CaseButtonsProps = {
  caseId: string;
  isCompareEnabled: boolean;
  handleCompareModalOpen: () => void;
};

export const CaseButtons = ({ caseId, isCompareEnabled, handleCompareModalOpen }: CaseButtonsProps) => {
  const navigate = useNavigate();

  const redirectToCaseDetails = () => {
    navigate(`/case/${caseId}`);
  };

  return (
    <div className="flex p-4 gap-3 bg-white rounded-b-2xl">
      <Button size="sm" variant="outline" onPress={handleCompareModalOpen} isDisabled={!isCompareEnabled}>
        Compare
      </Button>
      <Button size="sm" variant="light" onPress={redirectToCaseDetails}>
        View Case
      </Button>
    </div>
  );
};
